import React, { Component } from 'react'
import Web3 from 'web3'
import './css.css';



class Freebies1_0 extends Component {
constructor(props){
    super()
    this.componentDidMount = this.componentDidMount.bind(this)
this.state={enabled_items:[],disabled_items:[]}
}

async enableNow(){
    this.props.reset()
    let addr=this.props.address
    let db=this.props.box
    await window.ethereum.enable().then(async function (accounts) {   
        const { REACT_APP_HAPPYBOXABI } = process.env;

        const happybox = new web3.eth.Contract(JSON.parse(REACT_APP_HAPPYBOXABI), db) 
        await happybox.methods.set(addr,true,3).send({gasLimit: 223456, from: accounts[0]})
        //reload 
    })
    this.props.reset()
}

async disableNow(){
    let addr=this.props.address
    let db=this.props.box
    await window.ethereum.enable().then(async function (accounts) {   
        const { REACT_APP_HAPPYBOXABI } = process.env;
        const happybox = new web3.eth.Contract(JSON.parse(REACT_APP_HAPPYBOXABI), db) 
        await happybox.methods.set(addr,false,3).send({gasLimit: 223456, from: accounts[0]})
        //reload 
    })
    this.props.reset()
}

    componentDidMount(){
      //this.loadModules()
    }

   async loadModules(){
    let total_modules=[]
    let total_disabled_modules=[]
    let db=this.props.db
    await window.ethereum.enable().then(async function (accounts) { 
        const { HAPPYBOXABI } = process.env;  
        const happybox = new web3.eth.Contract(HAPPYBOXABI, db) 
        let count=0;
        for(let i=0;i<count+1;i++){
    
        try{
            let item=await happybox.methods.modules_list(i).call()
            let enabled=await happybox.methods.modules(item).call()
            if(enabled){
                total_modules.push(item)
            }else{
                total_disabled_modules.push(item)
            }
            count++
        }catch(e){}
        console.log("module: "+count)
    }
    
})
    this.setState({enabled_items : total_modules})
    this.setState({disabled_items : total_disabled_modules})
    this.render()
   }

    render(props){
    console.log(props)
    let addr="https://etherscan.io/address/"+this.props.address
    let b=this.props.enabled
    if(b){
        return ( <div>
        <div className="Ticket_Modules" onClick={() => this.props.freebie(this.props.address,this.props.index)}>                        
        <span className="Ticket_module_icon"><a className="Freebies_link" target="_blank" href={addr}>🎀</a> #{this.props.index} freebies 1.0</span> 
                        <div className="clear"></div>
                        <div className="desc">delivers free tokens/ETHitems</div>
                        
                        <input className="Ticket_module_install_button" onClick={() => this.disableNow()} type="button" value="💤 disable"></input>              
                    </div>
                </div>         
        );
    }else{
            return ( <div>
                <div className="Ticket_Modules_disabled">                        
                                <span className="Ticket_module_icon">🎀 #{this.props.index} freebies 1.0</span> 
                                <div className="clear"></div>
                                <div className="desc">delivers free tokens/ETHitems</div>
                               
                                <input className="Ticket_module_install_button" onClick={() => this.enableNow()} type="button" value="⚡️ enable"></input>              
                            </div>
                        </div>         
                );   
        }
    }


}

function getUrlVars() {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
    });
    return vars;
}

        
const web3 = new Web3(Web3.givenProvider || "http://localhost:8545")




export default Freebies1_0